import { SET_CURRENT_COURSE, SET_COURSE_PERCENT } from '../types';


export default function(course = null, action) {
  switch (action.type) {
    case SET_CURRENT_COURSE:
      return action.course;
    case SET_COURSE_PERCENT:
      return { ...course, passedPercent: action.passedPercent }
    default:
      return course;
  }
}
